import React from 'react';
import {
  FiAlertCircle,
  FiAward,
  FiCalendar,
  FiCheck,
  FiCheckCircle,
  FiCircle,
  FiClock,
  FiCompass,
  FiDollarSign,
  FiEdit,
  FiFileText,
  FiHeart,
  FiHome,
  FiImage,
  FiInfo,
  FiKey,
  FiLayers,
  FiLoader,
  FiLock,
  FiMap,
  FiMapPin,
  FiMessageCircle,
  FiSave,
  FiScissors,
  FiSearch,
  FiShield,
  FiSmile,
  FiStar,
  FiTag,
  FiUpload,
  FiUsers,
  FiVideo,
  FiX,
  FiXCircle,
  FiZap,
} from 'react-icons/fi';
import './AppIcon.css';

export const ICON_MAP = {
  home: FiHome,
  search: FiSearch,
  heart: FiHeart,
  wishlist: FiHeart,
  calendar: FiCalendar,
  booking: FiCalendar,
  message: FiMessageCircle,
  enquiry: FiMessageCircle,
  shield: FiShield,
  kyc: FiShield,
  key: FiKey,
  security: FiKey,
  lock: FiLock,
  dollar: FiDollarSign,
  sale: FiDollarSign,
  money: FiDollarSign,
  upload: FiUpload,
  post: FiUpload,
  project: FiLayers,
  build: FiLayers,
  layers: FiLayers,
  urgent: FiZap,
  featured: FiStar,
  star: FiStar,
  sparkle: FiStar,
  mapPin: FiMapPin,
  location: FiMapPin,
  verified: FiCheckCircle,
  check: FiCheck,
  checkCircle: FiCheckCircle,
  users: FiUsers,
  support: FiUsers,
  award: FiAward,
  trophy: FiAward,
  smile: FiSmile,
  map: FiMap,
  tag: FiTag,
  compass: FiCompass,
  video: FiVideo,
  image: FiImage,
  pdf: FiFileText,
  file: FiFileText,
  close: FiX,
  x: FiX,
  save: FiSave,
  loader: FiLoader,
  info: FiInfo,
  edit: FiEdit,
  scissors: FiScissors,
  crop: FiScissors,
  clock: FiClock,
  alert: FiAlertCircle,
  circle: FiCircle,
  draft: FiEdit,
  document: FiFileText,
  furnishing: FiHome,
  error: FiXCircle,
  zeroCommission: FiDollarSign,
  fast: FiZap,
  secure: FiLock,
  panIndia: FiMapPin,
  endToEnd: FiUsers,
  buy: FiHome,
  rent: FiKey,
  pointer: FiInfo,
};

/** Map legacy emoji strings from CMS/API to icon keys */
const LEGACY_EMOJI_MAP = {
  '🏠': 'home',
  '🔍': 'search',
  '♥': 'heart',
  '❤️': 'heart',
  '💖': 'heart',
  '💬': 'message',
  '📅': 'calendar',
  '🛡': 'shield',
  '🔑': 'key',
  '🔒': 'lock',
  '💰': 'money',
  '📤': 'upload',
  '🏗️': 'project',
  '🏗': 'project',
  '🔥': 'urgent',
  '⭐': 'featured',
  '✅': 'verified',
  '✔': 'verified',
  '💸': 'zeroCommission',
  '📍': 'mapPin',
  '⚡': 'fast',
  '🤝': 'endToEnd',
  '🏆': 'trophy',
  '😊': 'smile',
  '🏡': 'home',
  '🗺️': 'map',
  '🏷️': 'tag',
  '🏘️': 'home',
  '🖼': 'image',
  '📄': 'pdf',
  '📹': 'video',
  '📝': 'draft',
  '🧭': 'compass',
  '🛋': 'furnishing',
  '✨': 'sparkle',
  '👆': 'pointer',
  '⏳': 'loader',
  '💾': 'save',
  '✂️': 'scissors',
  '🟢': 'circle',
  '🟡': 'circle',
  '🗓': 'calendar',
  '⏰': 'clock',
  '❌': 'error',
};

export const resolveIconName = (name) => {
  if (!name) return null;
  if (ICON_MAP[name]) return name;
  if (LEGACY_EMOJI_MAP[name]) return LEGACY_EMOJI_MAP[name];
  return null;
};

const AppIcon = ({
  name,
  size = 18,
  className = '',
  strokeWidth = 2,
  color,
  style,
  spin = false,
}) => {
  const resolved = resolveIconName(name);
  const Icon = resolved ? ICON_MAP[resolved] : null;
  if (!Icon) return null;

  return (
    <Icon
      size={size}
      className={`app-icon${spin ? ' app-icon--spin' : ''}${className ? ` ${className}` : ''}`}
      strokeWidth={strokeWidth}
      color={color}
      style={style}
      aria-hidden
    />
  );
};

export default AppIcon;
